import { styled, css } from 'styled-components';

export const Container = styled.div<{
  $isOver: boolean;
  $isToday: boolean;
  $view: CalendarView;
}>`
  ${({
    theme: {
      colors,
      breakPoints: { mediumDevices },
    },
    $isOver,
    $isToday,
    $view,
  }) => css`
    align-items: flex-start;
    box-sizing: border-box;
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.25rem;
    min-height: 9rem;
    outline: 1px solid ${$isToday ? colors.brandPrimary : colors.brandDarkTint95};
    outline-offset: -1px;
    padding: calc(0.5rem + 1px);
    transition: all 0.12s ease;

    .creation-button {
      border-color: transparent;
      display: none;
      opacity: 0;
      pointer-events: none;
      visibility: hidden;
    }

    &:hover {
      .creation-button {
        border-color: ${colors.brandDarkTint90};
        display: ${$view === 'weekly' ? 'flex' : 'block'};
        opacity: 1;
        pointer-events: auto;
        visibility: visible;
      }
    }

    ${
      $isToday &&
      css`
        z-index: 1;
      `
    }

    ${
      $view === 'weekly' &&
      css`
        border-radius: 0.5rem;
        gap: 0.5rem;
        height: 100%;
        min-height: unset;
        overflow-y: auto;
      `
    }

    ${
      $isOver &&
      css`
        outline-color: ${colors.brandPrimaryTint50};
      `
    }

    @media screen and (${mediumDevices.max}) {
      padding: calc(0.075rem + 1px);

      .calendar-card {
        flex-direction: column;

        .calendar-card-content-area {
          padding: 0.25rem;
          place-self: stretch;
        }

        .calendar-card-thumb-area {
          height: 4rem !important;
          width: 100% !important;
        }
      }
    }

    @media print {
      border-radius: 0;
      border: 1px solid ${colors.brandDarkTint95};
      margin: 0 -1px -1px 0;
      padding: calc(0.075rem + 1px);
      position: relative;

      ${
        $view === 'weekly' &&
        css`
          background: transparent !important;
          border-radius: 0;
          gap: 0.25rem;
          height: 160mm;
          min-height: unset;
          overflow-y: auto;
          opacity: 1 !important;
          scrollbar-width: none;
          -ms-overflow-style: none;

          &::-webkit-scrollbar {
            display: none;
          }
        `
      }

      .calendar-card {
        .calendar-card-content-area {
          padding: 0.25rem;
          place-self: stretch;
        }

        .calendar-card-thumb-area {
          border-radius: 0.25rem !important;
          height: 100% !important;
          width: 2.5rem !important;
        }
      }
    }
  `}
`;
